import '@vfde-brix/button/dist/styles.css';
import '@vfde-brix/headline/dist/styles.css';
import '@vfde-brix/icon-text/dist/styles.css';
import '@vfde-brix/summary-tile/dist/styles.css';
import { createSummaryTileComponent } from '@vfde-brix/summary-tile';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-summary-tile', createSummaryTileComponent, NO_PATTERN_BUSINESS_LOGIC);
